import { ResolveFn } from '@angular/router';

import { catchError, map, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';

export const authResolver: ResolveFn<any> = (
  route,
  state
) => {
  const authService = inject(AuthService);

  return authService.user$.pipe(
    take(1),
    map(() => {}),
    catchError(() => of(null))
  );
};